import React, { useEffect, useState } from 'react';
import {IdeasListing} from '../components/ideaslisting.js';
import { observer } from "mobx-react-lite";
import {Link} from "react-router-dom";
import { useMst } from '../models/root';
const ImproveIdea = observer(()=>{

    return (
        <div class="absolute h-full w-full sm:w-2/5">
            <div className='w-ful h-32 text-xs bg-yellow-200'>

            </div>
            <div className='flex mt-6'>
                <textarea className='m-auto w-11/12 border-2 border-black h-60'/>
            </div>
            <div className='flex flex-row gap-4 justify-center mt-6'>
                <div className='bg-blue-700 text-white p-2 rounded'>Back</div>
                <div className=" p-2 rounded bg-white text-black border-2 border-black">Submit</div>
            </div>
        </div>
    );
})


export default ImproveIdea;